<template>
  <div class="h-full">
	<!-- <TopAppBar :title="title"> staticMode="true"</TopAppBar> -->
	<TopAppBar
	  :leftBtnMode="leftBtnMode"
	  :rightBtnMode="rightBtnMode"
	  :title="title"
	  :leftBtnMethod="leftBtnMethod"
	  :rightBtnMethod="rightBtnMethod"
    :hideCategory="false"
	  staticMode="true"
	>
	</TopAppBar>
	<div class="d-flex h-full flex-column">
	  <TopAppBarDrawer></TopAppBarDrawer>
	  <template v-if="!routerNameArr.includes(routerName)">
	  	<component :is="isListType"></component>
	  </template>
	  <transition name="fade" mode="out-in">
				<router-view></router-view>
	  </transition>
	</div>
  </div>
</template>

<script>
/**
 * 단독시험 메인 컴포넌트(independent exam main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from '@/components/TopAppBarDrawer.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js'

const routerNameArr = ['StoreView', 'StoreModify', 'StoreAdd']
export default {
	components: {
		'list': () => import('@/components/storeManagement/List.vue'),
		TopAppBarDrawer,
		TopAppBar,
	},

	data() {
		return {
			listType: 'list',
			isDrawerOpen: false,
			routerName: '',
			routerNameArr: routerNameArr,
			title: localStorage.getItem("brandName"),
		}
	},

	mixins: [topAppBarMixin],

	computed: {
		isListType() {
			this.routerName = this.$route.name;
			return this.$route.query.listType || 'list'
		}
	},
	watch:{
		$route (to, from){
			this.setTopAppBarHomeSearch(this.title)
		}
	},
	mounted() {
		// set header title
		let learnBack = localStorage.getItem("mytest");
		this.setTopAppBarHomeSearch(this.title);
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		openDrawer() {
			this.isDrawerOpen = true;
		},
		// Close drawer
		closeDrawer() {
			this.isDrawerOpen = false;
		},
		goToSearch() {
			this.$router.push({
				name: 'StoreProductCategory',
			})
		}
	}
}
</script>
